import { useEffect } from "react";
import { useRouter } from "next/router";
import { withAuthUser } from "next-firebase-auth";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useAuth } from "@/components/auth/hooks/useAuth";
import { useTranslation } from "next-i18next";
// BOOTSTRAP
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
// COMPONENTS
import BootstrapSpinner from "@/components/elements/LoadingPlaceholders/BootstrapSpinner";
import SideLinks from "@/components/core/CustomerService/SideLinks/SideLinks";
// ICONS
import { WhatsAppIcon } from "@/public/icons/icons";
// STYLE
import s from "./find-us.module.scss";
import { NextSeo } from "next-seo";
// i18n

function FindUs() {
  const auth = useAuth();
  const router = useRouter();

  const { t } = useTranslation("find-us");

  // If the user is not allowed will be redirect to homepage.
  useEffect(() => {
    if (auth.isUserSupplier()) {
      router.push("/home-supplier");
    }
  }, [[], auth]);

  return auth.isUserSupplier() ? (
    <BootstrapSpinner />
  ) : (
    <Container fluid className="px-0">
      <NextSeo
        title={t("find-us")}
        description={""}
        openGraph={{
          type: "website",
          title: t("find-us"),
          description: "",
          url: `${process.env.NEXT_PUBLIC_BASE_URL}/find-us`,
        }}
      />
      <Row key="catalogPage" className="mx-0 px-3">
        <div className={s.sideLinks}>
          <SideLinks />
        </div>
        <div className="px-0 d-block d-md-none">
          <h1 className="fs-1 fw-semibold text-center text-md-start">{t("find-us")}</h1>
          <p>{t("subtitle")}</p>
        </div>
        <Col xs={12} md={7}>
          <iframe
            src={`https://www.google.com/maps/embed/v1/place?q=place_id:ChIJhwMvUbhxiEcRUp_IdaNzvSQ&key=${process.env.NEXT_PUBLIC_MAPS_API_KEY}`}
            width="100%"
            height="640"
            className="border-0"
            allowFullScreen={true}
            loading="eager"
          ></iframe>
        </Col>
        <Col>
          <div>
            <div className="d-none d-md-block">
              <h1 className="fs-1 fw-semibold text-center text-md-start">{t("find-us")}</h1>
              <p>{t("subtitle")}</p>
            </div>
            <div className="d-flex flex-column text-center justify-content-center text-md-start py-5">
              <div className="d-flex flex-column mb-3">
                <a className="fw-semibold" href={`https://wa.me/${process.env.shopInfo["Contatti"].WhatsApp}`} target="_blank" rel="noreferrer">
                  <WhatsAppIcon width={24} height={24} color="black" strokeWidth={0.1} /> {t("whatsapp.title")}
                </a>
              </div>
              <div className="d-flex flex-column mb-3">
                <span className="fw-semibold">{t("phone.title")}</span>
                <a onClick={() => (window.location.href = `tel:${process.env.shopInfo["Contatti"].Telefono}`)} style={{ cursor: "pointer" }}>
                  {process.env.shopInfo["Contatti"].Telefono}
                </a>
                <span>{t("phone.text")}</span>
              </div>
              <div className="d-flex flex-column mb-3">
                <span className="fw-semibold">{t("email.title")}</span>
                <a onClick={() => (window.location.href = `mailto:${process.env.shopInfo["Contatti"].Email}`)} style={{ cursor: "pointer" }}>
                  {process.env.shopInfo["Contatti"].Email}
                </a>
              </div>
              <div className="d-flex flex-column mb-3">
                <span className="fw-semibold">{t("opening-hours.title")}</span>
                <span>{t("opening-hours.text1")}</span>
                <span>{t("opening-hours.text2")}</span>
                <span>{t("opening-hours.text3")}</span>
                <span>{t("opening-hours.text4")}</span>
              </div>
              <p className="d-flex flex-column mb-3">
                <span className="fw-semibold">{t("social-media.title")}</span>
                {/* <a  href="" className="text-decoration-underline">
                  Facebook
                </a>
                <a  href="" className="text-decoration-underline">
                  Twitter
                </a> */}
                <a href="https://www.instagram.com/kesy_pronto_moda/" target="_blank" rel="noreferrer" className="text-decoration-underline">
                  {t("social-media.text")}
                </a>
              </p>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common", "header", "footer", "find-us", "services-side-links", "db-translations"])),
    },
  };
}

export default withAuthUser({})(FindUs);
